// English display copy for the fixed common-mistake list defined in the API
// (api/index.py get_common_mistakes_for_category). The analysis model must return the
// list text verbatim, so it stays Chinese; these are human-written translations for the
// English UI. Scoring and evaluation matching keep using the original Chinese text.
// Keep this table in sync when the API list changes — unknown entries show as-is.
export const COMMON_MISTAKES_EN = {
  '卡頓詞窮': 'Hesitating or at a loss for words',
  '嗯嗯阿阿那那等贅字頻繁使用': 'Frequent filler words (um, uh, so…)',
  '不能說: 你還沒有聽, 怎麼就認為不需要':
    'Never say: "You haven\'t even heard me out—how can you already say you don\'t need it?"',
  '客戶如果說: 可是我沒有工作，可以辦嗎(實際上是不行，但專員不能直接說不行)':
    'If the customer asks "But I don\'t have a job—can I still apply?" (the answer is no, but the advisor must not say no directly)',
  '我保證給你市場最(優)/(底)價': '"I guarantee you the best / lowest price on the market."',
  '喔，那我先寄一個資料給你看看，有需要再找我':
    '"Oh, then let me just send you some information—contact me if you need anything."',
  '我們可以預核(預先核撥)一個XXX萬的額度給您':
    '"We can pre-approve (disburse in advance) a credit limit of NT$XXX0,000 for you."',
  '邀請您免費試算': '"We invite you to a free calculation."',
  '幫您簡易評估試算，不會產生任何費用': '"Let me do a quick assessment and calculation for you—there\'s no charge."'
};

export const localizeCommonMistake = (text, isEnglish) =>
  (isEnglish && typeof text === 'string' && COMMON_MISTAKES_EN[text]) || text;
